import { __extends } from "tslib";
import * as React from 'react';
import { Manager, Reference, Popper } from 'react-popper';
import './tooltip.scss';
var Tooltip = /** @class */ (function (_super) {
    __extends(Tooltip, _super);
    function Tooltip() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.state = {
            show: false,
        };
        _this.showTooltip = function () { return _this.setState({ show: true }); };
        _this.hideTooltip = function () { return _this.setState({ show: false }); };
        return _this;
    }
    Tooltip.prototype.render = function () {
        var _this = this;
        return (React.createElement(Manager, null,
            React.createElement("div", { className: "members-badges-lib-tooltip-style-wrapper" },
                React.createElement(Reference, null, function (_a) {
                    var ref = _a.ref;
                    return (React.createElement("div", { style: { position: 'relative' }, onMouseEnter: _this.showTooltip, onMouseLeave: _this.hideTooltip, ref: ref }, _this.props.children));
                }),
                React.createElement(Popper, { placement: "top", positionFixed: true }, function (_a) {
                    var ref = _a.ref, style = _a.style, placement = _a.placement;
                    return _this.state.show && (React.createElement("div", { className: "tooltip-wrapper", ref: ref, style: style, "data-placement": placement }, _this.props.message));
                }))));
    };
    return Tooltip;
}(React.Component));
export { Tooltip };
//# sourceMappingURL=Tooltip.js.map